'use strict';

const root = require('bunsen/helpers/windowCheck');
const ConnectedBaseView = require('../../global/reactHelpers/ConnectedBaseView');
const { connectGalleryStoreToView } = require('../helpers/connectViewToStoresHelpers');

const GalleryMobileNavWrapper = require('./GalleryMobileNavWrapper');
const GalleryPhotoWrapper = require('./GalleryPhotoWrapper');
const GalleryArrowBox = require('./GalleryArrowBox');
const PhotoDetails = require('./PhotoDetails');

const { classes } = require('../helpers/GalleryConstants');

/**
 * GalleryWrapperView
 * Top Level Connected Wrapper for views on Gallery Page
 */
const GalleryWrapperView = connectGalleryStoreToView(ConnectedBaseView).extend({
    el: `.${classes.GALLERY}`,

    /**
     * Props Object set by getPropsFromStore()
     *
     * @property {object} props
     * @property {bool}   props.isSetup
     * @property {string} [props.titleTag]
     * @property {string} [props.photoTitle]
     * @property {object} [props.photoFirm]
     * @property {object} [props.photoProject]
     * @property {array}  [props.photoAttrTags]
     */
    props: {},
    isModal: false, // set to true in GalleryModalWrapper
    pageType: '', // set in GalleryModalWrapper
    subViewsAreInitialized: false,
    subViewConfig: {
        mobileNav: {
            construct: GalleryMobileNavWrapper,
            singleton: true,
        },
        photo: {
            construct: GalleryPhotoWrapper,
            singleton: true,
        },
        arrows: {
            construct: GalleryArrowBox,
        },
        details: {
            construct: PhotoDetails,
            singleton: true,
        },
    },

    /**
     * Initializes each of the subviews and passes each the context
     */
    _initSubViews() {
        this.subs.add('mobileNav', { context: this.context, isModal: this.isModal });
        this.subs.add('photo', {
            context: this.context,
            isModal: this.isModal,
            pageType: this.pageType,
        });
        this.subs.add('arrows', {
            context: this.context,
            isModal: this.isModal,
            pageType: this.pageType,
        });
        this.subs.add('details', { context: this.context });
    },

    /**
     * Processes galleryStore and sets props before render
     * @see /gallery/stores/GalleryStore
     */
    getPropsFromStores(galleryStore) {
        const isSetup = galleryStore.isSetup();

        if (!isSetup) {
            return { isSetup };
        }

        return {
            isSetup,
            titleTag: galleryStore.getCurrentPageTitleTag(),
            showDetailsMobile: galleryStore.showDetailsMobile(),

            // props passed to PhotoDetails.es.js
            photoTitle: galleryStore.getCurrentPhotoTitle(),
            photoFirm: galleryStore.getPhotoFirm(),
            photoProject: galleryStore.getPhotoProject(),
            photoAttrTags: galleryStore.getCurrentPhotoTags(),
            photoCaption: galleryStore.getCurrentPhotoCaption(),
            similarItemsTemplate: galleryStore.getSimilarItemsTemplate(),
            moreProjectsTemplate: galleryStore.getMoreProjectsTemplate(),
        };
    },

    /**
     * Changes the title tag each time the galleryStore changes
     */
    render() {
        if (this.props.isSetup) {
            if (!this.subViewsAreInitialized) {
                this._initSubViews();
                this.subViewsAreInitialized = true;
            }

            this._updateDetails()._updateTitleTag();
        }
    },

    /**
     * Updates the gallery details
     * @returns {GalleryWrapperView}
     * @private
     */
    _updateDetails() {
        const { showDetailsMobile } = this.props;

        this.subs.get('details').passProps(this.props);

        if (showDetailsMobile) {
            this.$el.addClass(classes.STATE_SHOW_DETAILS);
        } else {
            this.$el.removeClass(classes.STATE_SHOW_DETAILS);
        }

        return this;
    },

    /**
     * Updates page's title
     * @returns {GalleryWrapperView}
     * @private
     */
    _updateTitleTag() {
        const { titleTag } = this.props;

        if (root.document.title !== titleTag) {
            root.document.title = titleTag;
        }

        return this;
    },
});

module.exports = GalleryWrapperView;



// WEBPACK FOOTER //
// ./assets/js/gallery/views/GalleryWrapperView.es.js